import React, { useState, useEffect } from 'react';
import axios from '../config/axiosConfig'; 
import { FaTimes, FaUser, FaBuilding, FaCheckCircle } from 'react-icons/fa';
import './AssignmentModal.css';

const AssignmentModal = ({ 
  isOpen, 
  onClose, 
  selectedWomenCount,
  employerRequests,
  onAssign,
  loading 
}) => {
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (employerRequests) {
      setFilteredRequests(employerRequests.filter(req => 
        req.employer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        req.department_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        req.email.toLowerCase().includes(searchTerm.toLowerCase())
      ));
    }
  }, [employerRequests, searchTerm]);

  if (!isOpen) return null;

  return (
    <div className="assignment-modal-overlay">
      <div className="assignment-modal">
        <div className="assignment-modal-header">
          <h3>Assign Women to Employer</h3>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="assignment-modal-body">
          <div className="assignment-summary">
            <FaUser className="summary-icon" />
            <div>
              <h4>{selectedWomenCount} women selected</h4>
              <p>Choose which employer request to assign them to</p>
            </div>
          </div>
          
          <div className="assignment-search">
            <input
              type="text"
              placeholder="Search employers or departments..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          
          <div className="requests-list">
            <h4>Approved Employer Requests</h4>
            {filteredRequests.length === 0 ? (
              <div className="no-requests">
                <p>No approved requests found</p>
              </div>
            ) : (
              filteredRequests.map(request => (
                <div 
                  key={request.request_id}
                  className={`request-item ${selectedRequest?.request_id === request.request_id ? 'selected' : ''}`}
                  onClick={() => setSelectedRequest(request)}
                >
                  <div className="request-info">
                    <div className="request-header">
                      <h5>{request.employer_name || request.full_name}</h5>
                      <span className="request-badge">{request.department_name}</span>
                    </div>
                    <div className="request-details">
                      <p><FaBuilding /> {request.department_name}</p>
                      <p><FaUser /> Requested: {request.number_of_employees} women</p>
                      <p>Email: {request.email}</p>
                      <p>Phone: {request.phone || 'N/A'}</p>
                    </div>
                  </div>
                  {selectedRequest?.request_id === request.request_id && (
                    <FaCheckCircle className="selected-icon" />
                  )}
                </div>
              ))
            )}
          </div>
        </div>
        
        <div className="assignment-modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button 
            className="btn btn-primary" 
            onClick={() => onAssign(selectedRequest)}
            disabled={!selectedRequest || loading}
          >
            {loading ? 'Assigning...' : `Assign to ${selectedRequest?.employer_name || 'Employer'}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignmentModal;